module.exports = __webpack_public_path__ + "static/media/photo_5.48c0c306.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/gallery/photo_5.jpg
// module id = 1638
// module chunks = 0